import {FiCopy} from "react-icons/fi";
import { useTranslation } from "react-i18next";
import styles from "./ExamBaseDuplicateModal.module.css";

const ExamBaseDuplicateModal = ({ isOpen, onConfirm, onCancel, disabled }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <div className={styles.iconWrap}>
                        <FiCopy className={styles.icon} aria-hidden />
                    </div>
                    <h3 className={styles.title}>{t("common.confirmTitle")}</h3>
                </div>

                <p className={styles.message}>
                    {t("modals.duplicateExamMessage")}
                </p>

                <div className={styles.actions}>
                    <button
                        type="button"
                        className={styles.cancelBtn}
                        onClick={onCancel}
                    >
                        {t("common.cancel")}
                    </button>
                    <button
                        type="button"
                        className={styles.confirmBtn}
                        onClick={onConfirm}
                        disabled={disabled}
                    >
                        {t("common.confirm")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExamBaseDuplicateModal;
